import { Suspense } from 'react';
import { Outlet } from 'react-router';

import { Loading } from '@portal/common/components';
import { styled } from '@portal/common/theme';

import Navigation from '../components/Navigation';
import RotateDeviceNotice from '../components/RotateDeviceNotice';

const Container = styled('div')(({ theme }) => ({
    display: 'flex',
    flexFlow: 'row nowrap',
    height: '100vh',
    // TODO: remove minWidth with responsive design
    minWidth: theme.minWidth.window,
}));

const Body = styled('div')({
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    minHeight: 0,
    height: '100%',
    overflow: 'hidden',
});

const LayoutWithSidenav = () => (
    <Container>
        <Navigation />
        <Body>
            <Suspense fallback={<Loading />}>
                <Outlet />
            </Suspense>
        </Body>
        <RotateDeviceNotice />
    </Container>
);

export default LayoutWithSidenav;
